import { WorkflowObjectState, Query, Predicate } from "olympe";
import BCP from "../../common/section_bcp/DM_BCP";
import { getApplicationContext } from '../../common/utils/Context';
import { editInputEstimatefield } from '../../common/utils/CommonUtil'

export const getDisplayNames = (bcpRequest) => {
  const DisplayNames = {
    businessPartnerName: bcpRequest?.get(BCP.businessPartnerProp)?.split(";")?.[0],
    procurementManagerName: bcpRequest?.get(BCP.procurementManagerProp)?.split(";")?.[0],
    ctagPersonName: bcpRequest?.get(BCP.technicalApplicationGroupProp)?.split(";")?.[0],
    sqaPersonName: bcpRequest?.get(BCP.qualityAssuranceProp)?.split(";")?.[0],
    qaFactoryPersonName: bcpRequest?.get(BCP.qaInFactoryProp)?.split(";")?.[0],
    procurementSpecialistPersonName: bcpRequest?.get(BCP.procurementSpecialistProp)?.split(";")?.[0],
  };
  return DisplayNames;
}
export const getLoggedInUserDisplayName = (context) => {
  const applicationContext = getApplicationContext(context);
  const loggedinUserDisplayName = applicationContext.get("userName")
  return loggedinUserDisplayName
}

export const getAlternativeEmail = (context) => {
  const applicationContext = getApplicationContext(context);
  const alternativeEmail = applicationContext.get("alternativeEmail")
  return alternativeEmail;
}
/**
 * @param {boolean} isAdmin
 * @param {string} email
 * @param {CloudObject} bcpRequest
 * @param {!BrickContext} $
 * @param {string} action
 * @return {boolean}
 */
export const canAcceptOrReject = async (isAdmin, email, bcpRequest, $) => {
  // Convert email to regex for matching
  console.log(" In canAcceptOrReject ", bcpRequest);
  const alternativeEmail = getAlternativeEmail($);
  const mailRegex = new RegExp(`.*${email}`, 'i');
  const alternativeEmailRegex = new RegExp(`.*${alternativeEmail}`, 'i');
  const loggedinUserDisplayName = getLoggedInUserDisplayName($)
  // Extract key roles and properties from bcpRequest
  const roles = {
    businessPartner: bcpRequest.get(BCP.businessPartnerProp),
    procurementManager: bcpRequest.get(BCP.procurementManagerProp),
    ctagPerson: bcpRequest.get(BCP.technicalApplicationGroupProp),
    sqaPerson: bcpRequest.get(BCP.qualityAssuranceProp),
    qaFactoryPerson: bcpRequest.get(BCP.qaInFactoryProp)
  };


  // Get the props values for column added for input saving,anycost and ghd reduction
  const alternativeVSCode = bcpRequest.get(BCP.alternativeVendorCodeProp);
  const anyCostSaving = bcpRequest.get(BCP.costSavingsProp)
  const ghdReduction = bcpRequest.get(BCP.ghgReductionProp)
  const inputEstimateEdit = bcpRequest.get(BCP.inputSavingEstimatesProp)
  const mainVendorLinkedAltVendor = bcpRequest.get(BCP.mainVendorLinkedAltVendorProp)
  // Now we have to validate if there is a new vendor to be added
  const vendorName = bcpRequest.get(BCP.vdetNameProp)
  const vendorAddress = bcpRequest.get(BCP.vdetAddressProp)
  const vendorCountry = bcpRequest.get(BCP.vdetCountryProp)
  const vendorCity = bcpRequest.get(BCP.vdetCityProp)
  const vendorContactNumber = bcpRequest.get(BCP.vdetContactNumberProp)
  const vendorEmail = bcpRequest.get(BCP.vdetEmailProp)

  // Get current state of the workflow
  const currentState = getCurrentWorkflow(bcpRequest, $)?.get(WorkflowObjectState.stateProp);
  const displayNames = getDisplayNames(bcpRequest);
  //validate code -check the condition for PM  state manadatory value
  const omFieldsValidateState = editInputEstimatefield(alternativeVSCode, mainVendorLinkedAltVendor,
    anyCostSaving, ghdReduction, inputEstimateEdit, vendorName, vendorAddress, vendorCountry,
    vendorCity, vendorContactNumber, vendorEmail
  )

  // Handle states with a switch statement
  switch (currentState) {
    case BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_1:
      return canQAFactoryAcceptance1(isAdmin, mailRegex, roles.sqaPerson, roles.qaFactoryPerson, loggedinUserDisplayName, displayNames, alternativeEmailRegex);

    case BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_2: {
      const qaApproved = await fetchQAApproved(bcpRequest);
      const findQaApproved = qaApproved?.toLowerCase();
      const adminApprovedQAAs = bcpRequest.get(BCP.adminFirstQualityAcceptanceProp);
      return canQAFactoryAcceptance2(isAdmin, mailRegex, findQaApproved, adminApprovedQAAs, roles, alternativeEmailRegex);
    }

    case BCP_WORKFLOW_STATES.ALT_VS_SUGG_BY_BP:
      return ((mailRegex.test(roles.businessPartner?.toLowerCase())
        || alternativeEmailRegex.test(roles.businessPartner?.toLowerCase())
        || loggedinUserDisplayName?.toLowerCase() === displayNames.businessPartnerName?.toLowerCase()
        || isAdmin)
        && (roles.qaFactoryPerson?.length > 0
          && roles.ctagPerson?.length > 0));

    case BCP_WORKFLOW_STATES.ALT_VS_CHECK_BY_PM:
      return ((mailRegex.test(roles.procurementManager?.toLowerCase())
          || alternativeEmailRegex.test(roles.procurementManager?.toLowerCase())
          || loggedinUserDisplayName?.toLowerCase() === displayNames?.procurementManagerName?.toLowerCase() ||
          isAdmin) && roles.sqaPerson?.length > 0 &&
        Boolean(omFieldsValidateState));

    case BCP_WORKFLOW_STATES.CTAG_ACCEPTANCE:
      return mailRegex.test(roles.ctagPerson?.toLowerCase()) ||
        alternativeEmailRegex.test(roles.ctagPerson?.toLowerCase())
        || loggedinUserDisplayName?.toLowerCase() === displayNames?.ctagPersonName?.toLowerCase() || isAdmin;

    default:
      return false;
  }
};

/**
 * @param {boolean} isAdmin
 * @param {string} email
 * @param {CloudObject} bcpRequest
 * @param {!BrickContext} $
 * @return {boolean}
 */
export const canEditQualityStakeholders = (isAdmin, email, bcpRequest, $) => {
  const mailRegex = new RegExp(`.*${email}`, 'i')
  const businessPartner = bcpRequest.get(BCP.businessPartnerProp);
  const currentState = getCurrentWorkflow(bcpRequest, $)?.get(WorkflowObjectState.stateProp);
  return (currentState === BCP_WORKFLOW_STATES.ALT_VS_SUGG_BY_BP && (mailRegex.test(businessPartner?.toLowerCase()) || isAdmin))
};

// Helper function to fetch QA Approval details
export async function fetchQAApproved(bcpRequest) {
  const res = await Query.from(bcpRequest)
    .follow(WorkflowObjectState.objectRel.getInverse())
    .filter(Predicate.equals(WorkflowObjectState.stateProp, BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_2))
    .execute();
  const assigneeProp = res.toArray()?.[0]?.get(WorkflowObjectState.assigneeProp)?.toLowerCase()
  return assigneeProp || null;
}

// Helper function for QA Factory Acceptance 1
function canQAFactoryAcceptance1(isAdmin, mailRegex, sqaPerson, qaFactoryPerson, loggedinUserDisplayName, 
  DisplayNames, alternativeEmailRegex) {

  return mailRegex.test(sqaPerson?.toLowerCase()) || 
    mailRegex.test(qaFactoryPerson?.toLowerCase()) ||
    alternativeEmailRegex.test(sqaPerson?.toLowerCase()) ||
    alternativeEmailRegex.test(qaFactoryPerson?.toLowerCase()) ||
    loggedinUserDisplayName?.toLowerCase() === DisplayNames.sqaPersonName?.toLowerCase() ||
    loggedinUserDisplayName?.toLowerCase() === DisplayNames?.qaFactoryPersonName?.toLowerCase() || isAdmin;
}

// Helper function for QA Factory Acceptance 2
function canQAFactoryAcceptance2(isAdmin, mailRegex, qaApproved, adminApprovedQAAs, roles, alternativeEmailRegex) {
  const { sqaPerson, qaFactoryPerson } = roles;
  if (qaApproved === sqaPerson?.split(';')?.[1]?.toLowerCase() || adminApprovedQAAs === ADMIN_FIRST_ACCEPTANCE.ACCEPT_AS_SQA) {
    return (mailRegex?.test(qaFactoryPerson?.toLowerCase())
    || alternativeEmailRegex?.test(qaFactoryPerson?.toLowerCase()) || isAdmin);
  }
  if (qaApproved === qaFactoryPerson?.split(';')?.[1]?.toLowerCase() 
  || adminApprovedQAAs === ADMIN_FIRST_ACCEPTANCE.ACCEPT_AS_QA_IN_FACTORY) {
    return (mailRegex?.test(sqaPerson?.toLowerCase()) || 
    alternativeEmailRegex?.test(sqaPerson?.toLowerCase()) || isAdmin);
  }
  return false;
}

/**
 * @param {boolean} isAdmin
 * @param {string} email
 * @param {CloudObject} bcpRequest
 * @return {boolean}
 */
export const canDelete = (isAdmin, email, bcpRequest) => {
  const mailRegex = new RegExp(`.*${email?.toLowerCase()}`);
  const requester = bcpRequest.get(BCP.requestorProp);
  const procurementSpecialist = bcpRequest.get(BCP.procurementSpecialistProp);
  return isAdmin || mailRegex.test(requester?.toLowerCase()) || mailRegex.test(procurementSpecialist?.toLowerCase());
};
export const canChangeAltVS = (isAdmin, email, bcpRequest, $) => {
  const mailRegex = new RegExp(`.*${email?.toLowerCase()}`);

  const businessPartner = bcpRequest.get(BCP.businessPartnerProp)?.toLowerCase();
  const procurementManager = bcpRequest.get(BCP.procurementManagerProp)?.toLowerCase();
  const procurementSpecialist = bcpRequest.get(BCP.procurementSpecialistProp)?.toLowerCase();
  const adminOrRequestor =
    isAdmin || mailRegex.test(bcpRequest.get(BCP.requestorProp)?.toLowerCase());
  const currentState = getCurrentWorkflow(bcpRequest, $)?.get(
    WorkflowObjectState.stateProp
  );
  const displayName = getDisplayNames(bcpRequest)
  const loggedinUserDisplayName = getLoggedInUserDisplayName($)
  return ((currentState === BCP_WORKFLOW_STATES.ALT_VS_SUGG_BY_BP &&
    (mailRegex.test(businessPartner?.toLowerCase())
      || loggedinUserDisplayName?.toLowerCase() === displayName.businessPartnerName?.toLowerCase()
      || adminOrRequestor || mailRegex.test(procurementSpecialist?.toLowerCase()))) ||
    (currentState === BCP_WORKFLOW_STATES.ALT_VS_CHECK_BY_PM &&
      (mailRegex.test(procurementManager?.toLowerCase())
        || loggedinUserDisplayName?.toLowerCase() === displayName?.procurementManagerName?.toLowerCase()
        || adminOrRequestor ||
        mailRegex.test(procurementSpecialist?.toLowerCase())))
  );
};
/**
 * @param {!CloudObject} cloudObject
 * @param {!BrickContext} $
 * @return {!WorkflowObjectState}
 */
export const getCurrentWorkflow = (cloudObject, $) => {
  const applicationContext = getApplicationContext($);
  const workflowContext = applicationContext.get('workflowContext');
  return $.get("Workflows") ? $.get("Workflows").get(cloudObject.getTag()) : workflowContext.get(cloudObject.getTag());
};

export const getLatestQualityApprover = (bcpRequest, curentWorkflow) => {
  const currentWorkflowState = curentWorkflow?.get(WorkflowObjectState.stateProp);
  const currentWorkflowAssignee = curentWorkflow?.get(WorkflowObjectState.assigneeProp)?.toLowerCase();
  let findWhoApproved;
  if (currentWorkflowState === BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_2) {
    // Map for role identification  
    const rolesMap = {
      1: "Accept as QA in the factory",
      2: "Accept as SQA"
    };

    // Check if the assignee matches `qaInFactoryProp` or `qualityAssuranceProp`  
    const qaInFactory = bcpRequest?.get(BCP.qaInFactoryProp)?.split(/[;:]/)?.[1]?.toLowerCase();
    const qualityAssurance = bcpRequest?.get(BCP.qualityAssuranceProp)?.split(/[;:]/)?.[1]?.toLowerCase();
    console.log("Determine QA currentWorkflowAssignee", currentWorkflowAssignee, bcpRequest.get(BCP.qaInFactoryProp));
    console.log("Determine QA qaInFactory --- qualityAssurance", qaInFactory, qualityAssurance);
    const adminFirstApproval = bcpRequest.get(BCP.adminFirstQualityAcceptanceProp);
    if (adminFirstApproval) {
      const adminFirstApproval = bcpRequest.get(BCP.adminFirstQualityAcceptanceProp);
      findWhoApproved = adminFirstApproval; // admin  
    }
    else {
      if (qaInFactory === qualityAssurance && qaInFactory === currentWorkflowAssignee) {
        findWhoApproved = rolesMap[1]; // qaInFactory if both match  
      } else if (qaInFactory === currentWorkflowAssignee) {
        findWhoApproved = rolesMap[1]; // qaInFactory  
      } else if (qualityAssurance === currentWorkflowAssignee) {
        findWhoApproved = rolesMap[2]; // qualityAssurance  
      }
    }
    console.log("Approval Role:", findWhoApproved);
  }
  return findWhoApproved;
}

/**
 * @enum {string}
 */
export const BCP_WORKFLOW_STATES = {
  ALT_VS_SUGG_BY_BP: "Alternative VS suggestion by BP",
  ALT_VS_CHECK_BY_PM: "Alternative VS check by PM",
  WAITING_ON_COMPLETION: "Waiting on completion criteria",
  CTAG_ACCEPTANCE: "CTAG acceptance",
  QA_FACTORY_ACCEPTANCE_1: "SQA_QA factory acceptance 1",
  QA_FACTORY_ACCEPTANCE_2: "SQA_QA factory acceptance 2",
  COMPLETED: "Completed",
  REJECTED: "Rejected",
};

/**
 * @enum {string}
 */
export const BCP_WORKFLOW_BUSINESS_NAMES = {
  "Alternative VS suggestion by BP": "BCP Request - Initiated",
  "Alternative VS check by PM": "BCP Request - BP Accepted",// BCP Request - BP Accepted
  "Waiting on completion criteria": "BCP Request - QA accepted",// BCP Request - QA accepted
  "Completed": "Completed",
  "Rejected": "Rejected",
  "CTAG acceptance": "BCP Request - PM Accepted", // BCP Request - PM Accepted
  "SQA_QA factory acceptance 1": "BCP Request - AG accepted", // BCP Request - AG accepted
  "SQA_QA factory acceptance 2": "BCP Request - QA accepted",// BCP Request - QA accepted
};
/**
 * @enum {number}
 */
export const BCP_WORKFLOW_ORDER = {
  "Alternative VS suggestion by BP": 0,
  "Alternative VS check by PM": 1,
  "Waiting on completion criteria": 2,
  "Completed": 6,
  "Rejected": 7,
  "CTAG acceptance": 3,
  "SQA_QA factory acceptance 1": 4,
  "SQA_QA factory acceptance 2": 5,
};

/**
 * @enum {string}
 */
export const ADMIN_FIRST_ACCEPTANCE = {
  ACCEPT_AS_SQA: 'Accept as SQA',
  ACCEPT_AS_QA_IN_FACTORY: 'Accept as QA in the factory',
};

export const allWorkflowStates = [
  { State: BCP_WORKFLOW_STATES.ALT_VS_SUGG_BY_BP, Assignee: "BP" },
  { State: BCP_WORKFLOW_STATES.ALT_VS_CHECK_BY_PM, Assignee: "PM" },
  { State: BCP_WORKFLOW_STATES.CTAG_ACCEPTANCE, Assignee: "CTAG" },
  { State: BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_1, Assignee: "QA's" },
  { State: BCP_WORKFLOW_STATES.WAITING_ON_COMPLETION, Assignee: "WC" },
];




//Enable inputsaving/ghg/maguire/costsaving/oscarid for BP,PM ,admin,requestor state to check all this fields should be editable.
export const checkBcpInputEdit = (isAdmin, email, bcpRequest, $) => {
  const mailRegex = new RegExp(`.*${email?.toLowerCase()}`);
  const procurementManager = bcpRequest.get(BCP.procurementManagerProp);
  const businessManager = bcpRequest.get(BCP.businessPartnerProp);
  const procurementSpecialist = bcpRequest.get(BCP.procurementSpecialistProp);
  const adminOrRequestor = isAdmin || mailRegex.test(bcpRequest.get(BCP.requestorProp)?.toLowerCase());
  const currentState = getCurrentWorkflow(bcpRequest, $)?.get(
    WorkflowObjectState.stateProp
  );
  const displayNames = getDisplayNames(bcpRequest);
  const loggedinUserDisplayName = getLoggedInUserDisplayName($)
  return (
    ((currentState === BCP_WORKFLOW_STATES.ALT_VS_CHECK_BY_PM ||
      currentState === BCP_WORKFLOW_STATES.CTAG_ACCEPTANCE ||
      currentState === BCP_WORKFLOW_STATES.ALT_VS_SUGG_BY_BP ||
      currentState === BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_1 ||
      currentState === BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_2 ||
      currentState === BCP_WORKFLOW_STATES.WAITING_ON_COMPLETION
    ) && (mailRegex.test(procurementManager?.toLowerCase()) || mailRegex.test(businessManager?.toLowerCase()) || adminOrRequestor
      || mailRegex.test(procurementSpecialist?.toLowerCase()) || loggedinUserDisplayName?.toLowerCase() === displayNames.businessPartnerName?.toLowerCase()
      || loggedinUserDisplayName?.toLowerCase() === displayNames?.procurementManagerName?.toLowerCase() ||
      loggedinUserDisplayName?.toLowerCase() === displayNames?.procurementSpecialistPersonName?.toLowerCase()))
  );
}

export const workflowStatesForApplyButtonDisabled = [
  BCP_WORKFLOW_STATES.COMPLETED,
  BCP_WORKFLOW_STATES.REJECTED,
];


// Reject button will be enable during all the BCP
export const canRejectDisable = async (isAdmin, email, bcpRequest, $) => {
  // Convert email to regex for matching
  const mailRegex = new RegExp(`.*${email?.toLowerCase()}`, 'i');

  // Extract key roles and properties from bcpRequest
  const roles = {
    businessPartner: bcpRequest.get(BCP.businessPartnerProp),
    procurementManager: bcpRequest.get(BCP.procurementManagerProp),
    ctagPerson: bcpRequest.get(BCP.technicalApplicationGroupProp),
    sqaPerson: bcpRequest.get(BCP.qualityAssuranceProp),
    qaFactoryPerson: bcpRequest.get(BCP.qaInFactoryProp),
  };

  // Get current state of the workflow
  const currentState = getCurrentWorkflow(bcpRequest, $)?.get(WorkflowObjectState.stateProp);

  //check the QA in factory person or admin
  const isQaFactoryOrAdmin = mailRegex.test(roles.qaFactoryPerson?.toLowerCase()) || isAdmin;

  // Handle states with a switch statement
  switch (currentState) {

    case BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_1:

      {
        const qaFactoryCheck = mailRegex.test(roles.qaFactoryPerson?.toLowerCase())
        const sqaAdminCheck = isAdmin || mailRegex.test(roles.sqaPerson?.toLowerCase())
        // Check in the QA1 state if the perosn is QA in factory person then enable the reject button and enable the reject button in QA1 state if person role is admin  or SQA
        return qaFactoryCheck || sqaAdminCheck

      }

    case BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_2:
      {
        const qaApproved = await fetchQAApproved(bcpRequest);
        const findQaApproved = qaApproved?.toLowerCase();
        const adminApprovedQAAs = bcpRequest.get(BCP.adminFirstQualityAcceptanceProp);
        const qa2AcceptanceCheck = canQAFactoryAcceptance2(isAdmin, mailRegex, findQaApproved, adminApprovedQAAs, roles);
        // Check in the QA2 state if the perosn is QA in factory person then enable the reject button  for Qa in factory person and enable the reject button in QA2 state ,it will check QA approve person and check Admin first acceptance then enable the reject button accrodingly.
        return isQaFactoryOrAdmin ? isQaFactoryOrAdmin : qa2AcceptanceCheck

      }

    case BCP_WORKFLOW_STATES.ALT_VS_SUGG_BY_BP:
      return (mailRegex.test(roles.businessPartner?.toLowerCase()) || isAdmin);

    case BCP_WORKFLOW_STATES.ALT_VS_CHECK_BY_PM:
      return (mailRegex.test(roles.procurementManager?.toLowerCase()) || isAdmin);

    case BCP_WORKFLOW_STATES.CTAG_ACCEPTANCE:
      return (mailRegex.test(roles.ctagPerson?.toLowerCase()) || isAdmin);

    case BCP_WORKFLOW_STATES.WAITING_ON_COMPLETION:
      // Check in the waiting on completion state if the perosn is QA in factory person then enable the reject button
      return isQaFactoryOrAdmin;

    case BCP_WORKFLOW_STATES.REJECTED:
      // Check in the waiting on completion state if the perosn is QA in factory person then enable the reject button
      return false;

    default:
      return false;
  }
};

//Enable priority and Target BCP  for BP,PM ,admin,requestor state to check this fields should be editable.
export const canDisablePriorityTargetBCP = (isAdmin, email, bcpRequest, $) => {
  const mailRegex = new RegExp(`.*${email?.toLowerCase()}`);
  const procurementManager = bcpRequest.get(BCP.procurementManagerProp);
  const businessManager = bcpRequest.get(BCP.businessPartnerProp);
  const procurementSpecialist = bcpRequest.get(BCP.procurementSpecialistProp);
  const adminOrRequestor = isAdmin || mailRegex.test(bcpRequest.get(BCP.requestorProp)?.toLowerCase());
  const currentState = getCurrentWorkflow(bcpRequest, $)?.get(
    WorkflowObjectState.stateProp
  );
  const displayNames = getDisplayNames(bcpRequest);
  const loggedinUserDisplayName = getLoggedInUserDisplayName($)
  return (
    ((currentState === BCP_WORKFLOW_STATES.ALT_VS_CHECK_BY_PM ||
      currentState === BCP_WORKFLOW_STATES.CTAG_ACCEPTANCE ||
      currentState === BCP_WORKFLOW_STATES.ALT_VS_SUGG_BY_BP ||
      currentState === BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_1 ||
      currentState === BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_2 ||
      currentState === BCP_WORKFLOW_STATES.WAITING_ON_COMPLETION
    ) && (mailRegex.test(procurementManager?.toLowerCase()) || mailRegex.test(businessManager?.toLowerCase()) || adminOrRequestor
      || mailRegex.test(procurementSpecialist?.toLowerCase()) || loggedinUserDisplayName?.toLowerCase() === displayNames?.businessPartnerName?.toLowerCase()
      || loggedinUserDisplayName?.toLowerCase() === displayNames?.procurementManagerName?.toLowerCase() ||
      loggedinUserDisplayName?.toLowerCase() === displayNames?.procurementSpecialistPersonName?.toLowerCase()))
  );
};

export const checkBcpInputSaving = (isAdmin, email, bcpRequest, $) => {
  const mailRegex = new RegExp(`.*${email?.toLowerCase()}`);
  const procurementManager = bcpRequest.get(BCP.procurementManagerProp);
  const businessManager = bcpRequest.get(BCP.businessPartnerProp);
  const procurementSpecialist = bcpRequest.get(BCP.procurementSpecialistProp);
  const adminOrRequestor = isAdmin || mailRegex.test(bcpRequest.get(BCP.requestorProp)?.toLowerCase());
  const currentState = getCurrentWorkflow(bcpRequest, $)?.get(
    WorkflowObjectState.stateProp
  );
  const displayNames = getDisplayNames(bcpRequest);
  const loggedinUserDisplayName = getLoggedInUserDisplayName($)
  const anyCostSaving = bcpRequest.get(BCP.costSavingsProp)
  if (anyCostSaving === "no") {
    return false;
  }
  return (
    ((currentState === BCP_WORKFLOW_STATES.ALT_VS_CHECK_BY_PM ||
      currentState === BCP_WORKFLOW_STATES.CTAG_ACCEPTANCE ||
      currentState === BCP_WORKFLOW_STATES.ALT_VS_SUGG_BY_BP ||
      currentState === BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_1 ||
      currentState === BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_2 ||
      currentState === BCP_WORKFLOW_STATES.WAITING_ON_COMPLETION
    ) && (mailRegex.test(procurementManager?.toLowerCase()) || mailRegex.test(businessManager?.toLowerCase()) || adminOrRequestor
      || mailRegex.test(procurementSpecialist?.toLowerCase()) || loggedinUserDisplayName?.toLowerCase() === displayNames.businessPartnerName?.toLowerCase()
      || loggedinUserDisplayName?.toLowerCase() === displayNames?.procurementManagerName?.toLowerCase() ||
      loggedinUserDisplayName?.toLowerCase() === displayNames?.procurementSpecialistPersonName?.toLowerCase()))
  );
}